module.exports = __webpack_public_path__ + "static/media/team.309edc07.jpg";